var _defs, _path, _path2, _path3, _g, _use, _path4, _path5, _use2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-ke",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    strokeMiterlimit: 10,
    d: "m-28.6 47.5 1.8 1 46.7-81c2.7-.6 4.2-3.2 5.7-5.8 1-1.8 5-8.7 6.7-17.7a58 58 0 0 0-11.9 14.7c-1.5 2.6-3 5.2-2.3 7.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v153.6H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 358.4h512V512H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "matrix(3.2 0 0 3.2 255.8 256)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    fill: "#fff"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 511.7 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    d: "M255.8 102.4c-19.2 0-51.2 51.2-60.8 76.8H0v153.6h195c9.7 25.6 41.7 76.8 60.9 76.8 19.2 0 51.2-51.2 60.8-76.8H512V179.2H316.6c-9.6-25.6-41.6-76.8-60.8-76.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M316.6 332.8a220 220 0 0 0 16-76.8 220 220 0 0 0-16-76.8 220 220 0 0 0-16 76.8 220 220 0 0 0 16 76.8"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 511.7 0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "matrix(3.2 0 0 3.2 255.8 256)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 4,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M1 5.8s4 8 4 21-4 21-4 21z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "scale(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "scale(1 -1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/ke.c70195b6db5693f8825135e3040d53a1.svg";
export { ForwardRef as ReactComponent };